import { CircularProgress } from '@ouster/webviz-react-components';

import { useEffect, useState } from 'react';
import { MdOutline3dRotation } from 'react-icons/md';
import { RxArrowRight } from 'react-icons/rx';
import { Link, useNavigate } from 'react-router-dom';

import { useKeycloak } from '../../KeycloakContext';
import { useStoreState, useStoreActions } from '../../reducers';
import styles from '../PublicPage.module.css';

/* 
  When user lands on the landing page, the app check whether there is 'idp_hint' in local storage.
    Yes - try to auto login user based on the idp_hint
      if the login doesn't work, user will stay on login page.
      if keycloak authentication pass, the app will check whether the user is existed in db
        if yes, user will be sent to drive list page.
        if no, user will stay on landing page.
    No - stay on page, no auto login happen
*/

// const idpHint = localStorage.getItem('idp_hint');

export default function LandingPage() {
  const { keycloak } = useKeycloak();
  const navigate = useNavigate();
  const { user, appUser } = useStoreState((storeState) => ({
    ...storeState.user,
  }));
  const { fetchUserRoleByIdentity } = useStoreActions(
    (actions) => actions.user
  );

  const [isFetchingUser, setIsFetchingUser] = useState(true);
  useEffect(() => {
    // Wait for keycloak to be initialized
    if (!keycloak) return;

    // If not authenticated, stop loading and show landing page
    if (!keycloak.authenticated) {
      setIsFetchingUser(false);
      return;
    }

    // If authenticated but no identity_id yet, keep loading
    if (keycloak.authenticated && !user?.identity_id) {
      setIsFetchingUser(true);
      return;
    }

    // If authenticated and identity_id is available, start authorization
    if (keycloak.authenticated && user?.identity_id) {
      const authorizeUser = async () => {
        setIsFetchingUser(true);
        try {
          await fetchUserRoleByIdentity(user.identity_id);
          navigate('/drive', { replace: true });
        } catch (error) {
          navigate('/sign_up', { replace: true });
        }
      };
      authorizeUser();
    }
  }, [keycloak, user?.identity_id, fetchUserRoleByIdentity, navigate]);

  if (!keycloak || isFetchingUser)
    return (
      <div className={styles['loading-container']}>
        <CircularProgress isIndeterminate size="50px" thickness={10} />
      </div>
    );

  /* 
    After authenticate and validate user's existence in database, there will be a flash of landing page before navigate to drive page.
    The line here is to prevent the flash happens.
  */
  if (appUser) return null;

  return (
    <div className={styles['landing-container']}>
      <div className={styles['landing-content']}>
        <div className={styles['copy-container']}>
          <h1 className={styles['landing-title']}>
            Unlock Lidar Visualization
          </h1>
          <p className={styles['landing-paragraph']}>
            Securely and effortlessly store, visualize, manage and share lidar
            data with Ouster Studio
          </p>
        </div>

        <div className={styles['button-section']}>
          <Link
            to="/sign_up"
            className={`${styles['primary-button']} ${styles['get-start-button']}`}
            data-testid="get-started-link"
          >
            Get Started <RxArrowRight size={18} />
          </Link>
          <Link
            to="/public"
            className={`${styles['secondary-button']} ${styles['get-start-button']}`}
            data-testid="explore-samples-link"
          >
            Explore Samples <MdOutline3dRotation size={24} />
          </Link>
        </div>
      </div>
    </div>
  );
}
